import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IExportCustomerDto,
  IExportGuestCustomerDto,
  IExportMenuDto,
  IMenuCategoryDto,
} from '../models';

@Injectable()
export class ExportService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getExportCustomerList(id: number): Observable<IExportCustomerDto[]> {
    return this.get(`admin/export/customer/${id}`);
  }

  public getExportGuestCustomerList(
    id: number
  ): Observable<IExportGuestCustomerDto[]> {
    return this.get(`admin/export/customer/guest/${id}`);
  }

  public getExportMenuListExcel(id: number): Observable<IMenuCategoryDto[]> {
    return this.get(`admin/export/menu/excel/${id}`);
  }

  public getExportMenuListPdf(id: number): Observable<IMenuCategoryDto[]> {
    return this.get(`admin/export/menu/pdf/${id}`);
  }

}
